import React from "react";
import styles from "../../../views/LoginDietitian/Component/Style.module.css";
import { CircularProgress, MenuItem, Tooltip, Typography } from "@mui/material";
import CustomPhoneContactField from "../../../../src/components/FormFields/CustomPhoneContact.componet";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import { useTheme } from "@mui/styles";
const PhoneNo = ({ errorData, changeTextData, form, isSubmitting,isPhoneDisabled }) => {
  const theme = useTheme();
  return (
  <>
  
      <div className={"headerFlex"}>
        {/* <h4 className={"infoTitle"}>
          <Typography variant={"title"} className={"heading"}>
            Personal Information
          </Typography>
          <Tooltip title="Info" aria-label="info" placement="right">
            <InfoIcon fontSize={"small"} />
          </Tooltip>
        </h4> */}
      </div>
      <div className={styles.outerFlex}>
        <div className={styles.lowerWrap}>
          <div className={"formFlex align-center"}>

            <div className={"formGroupphone"}>

              <CustomPhoneContactField
                isError={errorData?.contact}
                errorText={errorData?.contact}
                value={form?.contact}
                // contactType="Phone No"
                label={
                  <>
                    Phone No.
                    <span style={{ color: theme.palette.error.main }}>*</span>
                  </>}
                onTextChange={(text) => {
                  changeTextData(text, "contact");
                }}
                // disabled={isPhoneDisabled}
                placeholder=""
              />
            </div>

            {/* <div className={"formGroup formFlex1"}>
              <img src={phone} alt="phone" className={styles.phoneImg}></img>
              <div>
                <Typography variant="h5" sx={{ ml: 12 }}>Phone Number Required!</Typography>
                <Typography variant="body1" sx={{ ml: 12 }} >Please enter your phone number to proceed further</Typography>
              </div>
            </div> */}

            <div>
              {isSubmitting ? (
                <CircularProgress color="success" size="40px" />
              ) : (
                ""
              )}
            </div>

          </div>

        </div>
      </div>
      </>
  );
};

export default PhoneNo;